export default "__VITE_ASSET__BGmVUv3$__"